import Component from '../classes/Component';
import { $dom } from '../helpers/dom';
import { $events } from '../helpers/events';
import variables from '../variables';

const { get, attr, addClass, removeClass } = $dom;

const questionModalBodyId = 'js-question-modal';
const modalId = 'js-question-form';
const buttonSubmitSelector = `#${modalId} [type="submit"]`;
const inputNameSelector = `#${modalId} input[name="name"]`;
const inputPhoneSelector = `#${modalId} input[name="text"]`;
const inputQuestionSelector = `#${modalId} [name="question"]`;

export function modalForm() {

  const Page = this;
  const questionModalTitleSelector = '.js-question-modal-title';

  let questionModalTitle;
  let nameIsValid = false,
    phoneIsCorrect = false,
    questionIsCorrect = false;

  function checkTarget(t) {

    if (t instanceof Event) {
      return t.target;
    } else if (isElement(t)) {
      return t;
    }
  }

  function validateName(t) {
    let target = checkTarget(t);

    if (Boolean(target) && target.value.length > 0) {
      nameIsValid = true;
    } else {
      nameIsValid = false;
    }
  }

  function validatePhone(t) {
    let target = checkTarget(t);

    if (Boolean(target) && target.value.length >= 18) {
      phoneIsCorrect = true;
    } else {
      phoneIsCorrect = false;
    }
  }

  function validateQuestion(t) {
    let target = checkTarget(t);

    if (Boolean(target) && target.value.length > 0) {
      questionIsCorrect = true;
    } else {
      questionIsCorrect = false;
    }
  }

  function handleFormSubmit(event) {
    event.preventDefault();

    const formData = new FormData(event.target);
    const url = attr(event.target, "action");
    const method = attr(event.target, "method");

    if (!nameIsValid || !phoneIsCorrect || !questionIsCorrect) {
      console.log('uncorrect');
      return;
    }

    fetch(url, {
      method: method,
      body: formData
    })
      .then(response => response.json())
      .then(result => {

        switch (result.code) {
          case 'success':
            Page.toast.show('Успешно отправлено', 'success');
            break;
          case 'error':
            Page.toast.show(result.errors, 'danger');
            break;
        }

        const inputName = get(inputNameSelector);
        const inputPhone = get(inputPhoneSelector);
        const inputQuestion = get(inputQuestionSelector);

        inputName.value = '';
        inputPhone.value = '';
        inputQuestion.value = '';

      })
      .finally(() => {
        questionModalTitle = get(questionModalTitleSelector).innerHTML

        get(questionModalTitleSelector).innerHTML = variables.formValidationMessages.sended;

        addClass(get(`#${modalId}`), 'd-none');

        nameIsValid = phoneIsCorrect = questionIsCorrect = false;
      });
  }

  return new Component({
    name: 'modalForm',
    requiredSelector: '#' + modalId,
    onCreate() { },
    onInit() {
      $events.delegate
        .on('submit', '#' + modalId, handleFormSubmit)
        .on('input', inputNameSelector, validateName)
        .on('input', inputPhoneSelector, validatePhone)
        .on('input', inputQuestionSelector, validateQuestion)
        .on('hidden.bs.modal', "#" + questionModalBodyId, () => {
          nameIsValid = phoneIsCorrect = questionIsCorrect = false;
          if (questionModalTitle) get(questionModalTitleSelector).innerHTML = questionModalTitle;
          removeClass(get(`#${modalId}`), 'd-none');
        })
    },
    onDestroy() {
      $events.delegate
        .off('submit', '#' + modalId, handleFormSubmit)
        .off('input', inputNameSelector, validateName)
        .off('input', inputPhoneSelector, validatePhone)
        .off('input', inputQuestionSelector, validateQuestion)
        .off('hidden.bs.modal', "#" + questionModalBodyId, () => {
          nameIsValid = phoneIsCorrect = questionIsCorrect = false;
          if (questionModalTitle) get(questionModalTitleSelector).innerHTML = questionModalTitle;
          removeClass(get(`#${modalId}`), 'd-none');
        })
    }
  })
}